import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  /** Text to display below the spinner */
  text?: string;
  /** Size variant - small, medium, or large */
  size?: 'small' | 'medium' | 'large';
  /** Whether to center the spinner in its container */
  centered?: boolean;
  /** Custom color for the spinner (defaults to purple theme) */
  color?: string;
  /** Whether to show only the spinner without text */
  spinnerOnly?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  text = 'Loading...', 
  size = 'medium',
  centered = true,
  color,
  spinnerOnly = false
}) => {
  return (
    <div 
      className={`loading-spinner-wrapper ${size} ${centered ? 'centered' : ''}`}
      style={color ? { '--spinner-color': color } as React.CSSProperties : undefined}
    >
      <div className="loading-spinner-circle" />
      {!spinnerOnly && <span className="loading-spinner-text">{text}</span>}
    </div>
  );
};

export default LoadingSpinner;
